import TweenMax from 'gsap/TweenMax';

export default function Jet(container, canvas, duration, beforeAnimation) {
  const {
    top: containerTop,
    right: containerRight,
    width: containerWidth,
  } = container.getBoundingClientRect();

  const {
    top: canvasTop,
    left: canvasLeft,
    height: canvasHeight,
  } = canvas.getBoundingClientRect();
  const initialX = canvasLeft - containerRight + containerWidth / 2;
  const initialY = containerTop - canvasTop + 0.2 * canvasHeight;

  beforeAnimation(initialX, initialY);

  TweenMax.to(container, 0.25, {
    opacity: 1,
  });
}
